export function readFile (file, callback) {
  const reader = new FileReader()

  reader.onload = (e) => {
    try {
      const content = e.target.result

      callback(content)
    } catch (error) {
      console.error('Error reading file:', error)
    }
  }

  reader.onerror = (error) => {
    console.error('Error reading file:', error)
  }

  reader.readAsText(file)
}

export function downloadFile (name, type, data) {
  try {
    const jsonBlob = new Blob([data], { type })
    const url = URL.createObjectURL(jsonBlob)

    const link = document.createElement('a')
    link.href = url
    link.download = name
    document.body.appendChild(link)
    link.click()

    // Cleanup to free memory
    URL.revokeObjectURL(url)
    document.body.removeChild(link)
  } catch (error) {
    console.error('Error downloading file:', error)
  }
}
